import React, { useEffect, useState } from "react";
import FarmerComponent from "../../components/Farmer/Farmer.js";

const Reports = () => {
  //   return
  return <FarmerComponent />;
};

export default Reports;
